'use strict';
// @flow

import * as Immutable from 'immutable';
import { push } from 'react-router-redux';
import { createSelector } from 'reselect';

import type { Action, Dispatch, State } from 'lib/types';
import { decamelizeObjectKeys } from 'lib/viewUtils';
import { fetchJSON, json } from 'lib/api/fetch';
import request from 'lib/request';

import { ajaxError, alert } from 'reducers/alerts';

export const DETALHES_CARREGANDO = 'ferramentas/noticia/detalhes/DETALHES_CARREGANDO',
             DETALHES_CARREGADO  = 'ferramentas/noticia/detalhes/DETALHES_CARREGADO';

const INITIAL_STATE = Immutable.fromJS({
  carregando: false,
  item: {},
});

export default function reducer(state : any = INITIAL_STATE, action : Action = {}) {
  switch (action.type) {
    case DETALHES_CARREGANDO:
      return state.set('carregando', true).set('item', Immutable.fromJS({}));
    case DETALHES_CARREGADO:
      return state.set('carregando', false).set('item', action.body);

    default:
      return state;
  }
}

// selectors

export const rootSelector = (state : State) => state.getIn(['ferramentas', 'noticia', 'detalhes'], Immutable.Map());
export const itemSelector = createSelector<*, *, *, *>(rootSelector, (root) => root.get('item'));
export const carregandoSelector = createSelector<*, *, *, *>(rootSelector, (root) => root.get('carregando', false));

// actions

export function detalhesCarregando() {
  return { type: DETALHES_CARREGANDO };
}

export function detalhesCarregado(item : any) {
  return { type: DETALHES_CARREGADO, body: Immutable.fromJS(item) };
}

// thunk actions

export function navigateToIndex() {
  return push('/app/ferramentas/noticias');
}

export function carregaDetalhes(id : string) {
  return async function(dispatch : Dispatch<any>) {
    dispatch(detalhesCarregando());

    const url = id ? `/app/ferramentas/noticias/${ id }` : `/app/ferramentas/noticias/new`;

    dispatch(push(url));

    await request.get(url)
        .accept('json')
        .then(r => dispatch(detalhesCarregado(r.body)))
        .catch(e => {
          dispatch(ajaxError('Erro ao carregar detalhes da notícia', e));
        });
  };
}

export function excluiNoticia(id : string) {
  return async function(dispatch : Dispatch<*>) {
    await request.delete(`/app/ferramentas/noticias/${ id }`)
        .accept('json')
        .query({ id })
        .then(async() => {
          await dispatch(push('/app/ferramentas/noticias'));
          dispatch(alert('info', 'Notícia excluída.'));
        })
        .catch(e => dispatch(ajaxError('Erro ao excluir notícia', e)));
  };
}

export async function atualizaNoticia(id : string, form : any) {
  return await fetchJSON(`/app/ferramentas/noticias/${ id }`, json('PATCH', decamelizeObjectKeys(form)));
}

export async function criaNoticia(form : any) {
  return await fetchJSON(`/app/ferramentas/noticias`, json('POST', decamelizeObjectKeys(form)));
}
